'use client'

import { styled } from '@mui/material'
import { PageLayout } from '../pageLayout'

export const StyledSitemap = styled(PageLayout)(({ theme }) => ({
  '.sitemap-content': {
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',

    a: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    'a span': {
      fontWeight: 700,
    },
    ul: {
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(3),
      li: {
        marginBottom: theme.spacing(2),
      },
    },
  },
}))